import React, {useRef, useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import HoverVideoPlayer from "react-hover-video-player";
import StripePayment from "./Stripe/StripePayment";
import Modal from "react-modal";
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../utils/currency';
import "../styles/scrollbar.css";

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
    width: "100%",
    backgroundColor: "#111",
    color: "#fff",
    position: "relative",
  },
  sidebar: {
    flex: "0 0 300px",
    backgroundColor: "#1c1c1c",
    padding: "20px",
    overflowY: "auto",
    borderRight: "1px solid #333",
  },
    thumbnail: {
    width: "80px",
    height: "45px",
    marginRight: "10px",
    overflow: "hidden",
    borderRadius: "5px",
  },
  mainContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    overflowY: "auto",
  },
  videoWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: "2560px", // fixed typo (px)
    margin: "0 auto",
    aspectRatio: "16/9",
    backgroundColor: "#000",
    borderRadius: "10px",
    overflow: "hidden",
  },
video: {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "contain",
  backgroundColor: "#000",
},


  closeBtn: {
    position: "absolute",
    top: "15px",
    right: "15px",
    background: "#DFBD69",
    color: "#000",
    border: "none",
    borderRadius: "50%",
    fontSize: "20px",
    width: "35px",
    height: "35px",
    cursor: "pointer",
    zIndex: 2100,
  },
  tabs: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  tab: (active) => ({
    flex: 1,
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    background: active ? "#facc15" : "#333",
    color: active ? "#000" : "#fff",
    fontWeight: "bold",
    transition: "0.3s",
  }),
  responsive: `
    /* ===== Global Utility ===== */
    .hide { display: none !important; }
    .course-toggle-btn {
      display: none;
      position: fixed;
      top: 10px;
      left: 10px;
      z-index: 2500;
      background: #DFBD69;
      color: #111;
      border: none;
      padding: 10px 14px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 6px;
      box-shadow: 0 2px 6px rgba(0,0,0,.4);
      cursor: pointer;
    }
    .course-sidebar { transition: transform .35s ease, opacity .35s ease; }
    .course-sidebar.mobile-hidden { transform: translateX(-110%); opacity: 0; pointer-events: none; }
    .course-sidebar.mobile-visible { transform: translateX(0); opacity: 1; }
    .course-main { transition: margin .35s ease; }

    /* ✅ Tablets & small laptops */
  @media (max-width: 900px) {
      .course-container {
        flex-direction: column !important;
      }
      .course-sidebar {
        width: 100% !important;
        order: 1 !important;
        border-right: none !important;
        border-bottom: 1px solid #333;
      }
      .course-main {
        width: 100% !important;
        order: 2 !important;
        margin-top: 15px !important;
      }
    }

    /* ✅ Mobile ≤768px */
    @media (max-width: 768px) {
      .course-toggle-btn { display: inline-block; }
      .course-container { flex-direction: column !important; }
      .main-container { flex-direction: column !important; }
      .course-sidebar {
        position: fixed;
        top: 0; left: 0; bottom: 0;
        width: 78%;
        max-width: 340px;
        background: #1c1c1c;
        border-right: 1px solid #333;
        padding: 70px 16px 20px 16px !important; /* space for toggle button */
        z-index: 2400;
        overflow-y: auto;
        box-shadow: 4px 0 12px rgba(0,0,0,.5);
      }
      .course-main { width: 100% !important; padding: 70px 12px 20px 12px !important; }
      .video-wrapper { max-width: 100% !important; aspect-ratio: 16/9 !important; border-radius: 6px !important; }
      video { max-width: 100% !important; height: auto !important; }
      .course-item { padding: 10px 6px !important; }
      .course-item h4 { font-size: 14px !important; }
      .course-item p { font-size: 12px !important; }
    }

    /* ✅ Very small phones ≤425px */
    @media (max-width: 425px) {
      .course-container,
      .main-container {
        flex-direction: column !important;
      }
      .course-sidebar {
        width: 100% !important;
        max-height: 220px !important;
        padding: 5px !important;
        order: 1 !important;
        border-bottom: 1px solid #444;
      }
      .course-main {
        width: 100% !important;
        order: 2 !important;
        margin-top: 15px !important;
        padding: 8px !important;
      }

      .course-item {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        padding: 8px !important;
        border-bottom: 1px solid #444;
      }
      .course-item img {
        width: 100% !important;
        height: auto !important;
        margin-bottom: 6px;
        border-radius: 6px;
      }
      .course-title {
        font-size: 14px !important;
        font-weight: 600;
        margin-bottom: 4px;
      }
      .course-desc {
        font-size: 12px !important;
        line-height: 1.4;
        margin-bottom: 4px;
      }
      .price-tag {
        font-size: 12px !important;
      }

      h2 {
        font-size: 18px !important;
      }
      p, li {
        font-size: 14px !important;
      }

      .tabs {
        flex-direction: column !important;
      }
      .tabs button { width: 100% !important; margin-bottom: 6px !important; }
    }
    /* Ultra small ≤360px */
    @media (max-width: 360px) {
      .course-toggle-btn { font-size: 12px; padding: 8px 10px; }
      .course-item h4 { font-size: 13px !important; }
      .course-item p { font-size: 11px !important; line-height: 1.35 !important; }
      .price-tag { font-size: 11px !important; }
      h2 { font-size: 17px !important; }
      h3 { font-size: 15px !important; }
      p, li { font-size: 13px !important; }
      .course-sidebar { padding-top: 66px !important; }
    }
  `,
};

// Breakpoints constants for reuse in logic (not altering API)
const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

// Memoized single course item to reduce sidebar list re-renders
const CourseItem = React.memo(function CourseItem({ course, selectedCourseId, onSelect, getVideoSrc, isCoursePurchased, isMobile, isLoggedIn, onRequireSignIn }) {
  const { convert, format } = useCurrency();
  const purchased = isCoursePurchased(course);
  return (
    <div
      key={course.ID}
      className="course-item"
      style={{
        ...styles.courseItem,
        backgroundColor: selectedCourseId === course.ID ? "#2a2a2a" : "transparent",
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={() => {
        if (!isLoggedIn) {
          if (onRequireSignIn) onRequireSignIn(course);
          return;
        }
        onSelect(course, purchased);
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isLoggedIn) {
            if (onRequireSignIn) onRequireSignIn(course);
            return;
          }
          onSelect(course, purchased);
        }
      }}
      aria-pressed={selectedCourseId === course.ID}
    >
      <div style={styles.thumbnail} className="thumbnail" aria-hidden="true" onContextMenu={(e) => e.preventDefault()}>
        {/* Skip hover video on mobile for performance */}
        {!isMobile ? (
          <HoverVideoPlayer
            videoSrc={getVideoSrc(course)}
            style={styles.videoStyle}
            videoProps={{
              controlsList: 'nodownload',
              onContextMenu: (e) => e.preventDefault(),
              disablePictureInPicture: true,
              disableRemotePlayback: true,
            }}
          />
        ) : (
          <div style={{width:'100%',height:'100%',background:'#222',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,color:'#aaa',borderRadius:4}}>Video</div>
        )}
      </div>
      <div style={{...styles.courseMeta, flex:1, minWidth:0}}>
        <h4 style={{...styles.courseTitle, margin:'0 0 4px', fontSize:14, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}} title={course.TITLE}>
          {course.TITLE}
        </h4>
        <p style={{...styles.courseDesc, margin:'0 0 4px', fontSize:12, lineHeight:1.4, display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden'}}>
          {course.COURSE_DESC}
        </p>
        {course.CASH_AMT > 0 && (
          purchased ? (
            <span style={{ ...styles.priceTag, color: 'green', fontSize:11 }}>Paid</span>
          ) : (
            <span style={{ ...styles.priceTag, fontSize:11 }}>{format(convert(course.CASH_AMT))}</span>
          )
        )}
      </div>
    </div>
  );
});


const CourseList = () => {
  const [activeTab, setActiveTab] = useState("free");
  const [activeTabVideo, setActiveTabVideo] = useState("overview");
  // ADD THESE NEW STATES:
  const [paidModules, setPaidModules] = useState([]); // Store paid course modules
  const [advancedModules, setAdvancedModules] = useState([]); // Store advanced course modules (affiliate-only)
  const [selectedModule, setSelectedModule] = useState(null); // Track selected module
  const [showModuleList, setShowModuleList] = useState(true); // Toggle between module list and lessons
  const [expandedModuleUIDs, setExpandedModuleUIDs] = useState(new Set()); // Track which modules are expanded
  const { t, i18n } = useTranslation();
  const { currency, convert, format } = useCurrency();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );
  const videoRef = useRef(null);
  const [showMainVideo, setShowMainVideo] = useState(false);
  const [activeSidebarVideo, setActiveSidebarVideo] = useState(null);
  // Mobile sidebar toggle
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    let frame; // throttle with rAF
    const handleResize = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setViewportWidth(window.innerWidth));
    };
    window.addEventListener('resize', handleResize, { passive: true });
    return () => { window.removeEventListener('resize', handleResize); if (frame) cancelAnimationFrame(frame); };
  }, []);
  const isMobile = viewportWidth <= MOBILE_BREAKPOINT;
  const isTablet = viewportWidth > MOBILE_BREAKPOINT && viewportWidth <= TABLET_BREAKPOINT;

  // Lock page scroll while the mobile sidebar is open. The page scrolls inside the
  // layout's <main> (not the body), so lock every scrollable ancestor plus the body.
  const pageRootRef = useRef(null);
  useEffect(() => {
    if (!((isMobile || isTablet) && isSidebarOpen)) return;
    const locked = [document.body, document.documentElement];
    for (let el = pageRootRef.current?.parentElement; el && el !== document.body; el = el.parentElement) {
      if (/(auto|scroll)/.test(getComputedStyle(el).overflowY)) locked.push(el);
    }
    const prev = locked.map((el) => el.style.overflow);
    locked.forEach((el) => { el.style.overflow = 'hidden'; });
    return () => locked.forEach((el, i) => { el.style.overflow = prev[i]; });
  }, [isMobile, isTablet, isSidebarOpen]);

  // Prevent right-click context menu specifically on video elements and video containers
  useEffect(() => {
    const handler = (e) => {
      try {
        const el = e.target;
        if (!el) return;
        // If the click is on a video element or inside known video containers, block the menu
        if (
          el.tagName === 'VIDEO' ||
          (el.closest && (el.closest('video') || el.closest('.ll-main-video') || el.closest('.ll-course-thumb') || el.closest('.thumbnail')))
        ) {
          e.preventDefault();
        }
      } catch (err) {
        // ignore
      }
    };
    document.addEventListener('contextmenu', handler);
    return () => document.removeEventListener('contextmenu', handler);
  }, []);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [coursesvideos, setCoursesVideos] = useState({ free: [], paid: [], advanced: [] });
  const [isAffiliate, setIsAffiliate] = useState(false); // whether current user is an affiliate/partner
  const [userProfile, setUserProfile] = useState(null); // store fetched profile for code checks
  const [purchasedCourses, setPurchasedCourses] = useState([]); // State for purchased courses
  const navigate = useNavigate();
  const ID = localStorage.getItem("userID");
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [currentCoins, setCurrentCoins] = useState();
  const [currentComCoins, setCurrentComCoins] = useState();
  const [loadingTimestamps, setLoadingTimestamps] = useState(false);
  const [handlePaymentSuccess, setHandlePaymentSuccess] = useState(false);
  const [message, setMessage] = useState(""); // If not already defined

  const [showGemConfirmModal, setShowGemConfirmModal] = useState(false);
  const [showGemSuccessModal, setShowGemSuccessModal] = useState(false);

  const [showGemErrorModal, setShowGemErrorModal] = useState(false);
  const [gemErrorMessage, setGemErrorMessage] = useState("");
  const [insufficientGemsModal, setInsufficientGemsModal] = useState({ show: false, required: 0, current: 0 });

  const [isGemPaymentLoading, setIsGemPaymentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [purchasedCourseTitle, setPurchasedCourseTitle] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // Add this useEffect to check login status
  useEffect(() => {
    const userID = localStorage.getItem("userID");
    const username = localStorage.getItem("username");
    setIsLoggedIn(Boolean(userID && username));
  }, []);

  const openRightSignIn = useCallback(() => {
    window.dispatchEvent(new CustomEvent("openSignInPanel"));
  }, []);


  const closeSuccessModal = () => {
    setHandlePaymentSuccess(false);
    setMessage("");
  };

  const [handlePaymentFailed, setHandlePaymentFailed] = useState(false);

  const closeFailedModal = () => {
    setHandlePaymentFailed(false);
    setMessage("");
  };
  const domain = "https://xianhefairy.com/LotusFairy_API/api/booking/";
  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     try {
  //       const response = await fetch(`${domain}getCF`);
  //       const apiData = await response.json();

  //       const freeCourses = apiData.filter((course) => course.FILE_TYPE === 0);
  //       const paidCourses = apiData.filter((course) => course.FILE_TYPE === 1);

  //       setCoursesVideos({
  //         free: freeCourses,
  //         paid: paidCourses,
  //       });
  //     } catch (error) {
  //       console.error("Error fetching course data:", error);
  //     }
  //   };

  //   fetchCourses();
  // }, []);

  const fetchPaidCourses = async () => {
    try {
      // Get language ID from localStorage, default to 2224 (English)
      const langId = localStorage.getItem('languageId') || '2224';
      
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Course/GetPaidCourses?CustId=${ID}&LangId=${langId}`);
      const apiData = await response.json();

      console.log('Fetched paid courses with access:', apiData);

      // Clear arrays first
      const modules = [];
      const individualVideos = [];
      let advModules = [];
      let advIndividualVideos = [];

      // Map paid results (some items may already be marked advanced)
      apiData.forEach((item) => {
        const title = item.Title || '';
        const isAdvanced = item.IsAdvanced === true || item.Is_Advanced === 1 || item.ADVANCED === true || /advanced/i.test(title);

        if (item.Courses && item.Courses.length > 0) {
          const mappedModule = {
            UID: item.Uid,
            TITLE: item.Title,
            COURSE_DESC: item.CourseDesc,
            MASTER_NAME: item.MasterName,
            LEARNING_OBJECTIVES: item.LearningObjectives,
            SKILLS_COVERED: item.SkillsCovered,
            CASH_AMT: item.CashAmt,
            GEM_AMT: item.GemAmt,
            OTHER_AMT: item.GemAmt,
            ACCESS: item.Access === 1 || item.UserAccess === "True" || item.UserAccess === true ? 1 : 0,
            USER_ACCESS: item.UserAccess,
            COURSES: item.Courses.map((course) => ({
              HUID: course.Huid,
              SEQ: course.Seq,
              ID: course.Seq,
              UID: course.Uid,
              TITLE: course.Title,
              COURSE_DESC: course.CourseDesc,
              MASTER_NAME: course.MasterName,
              LEARNING_OBJECTIVES: course.LearningObjectives,
              SKILLS_COVERED: course.SkillsCovered,
              VIDEO_URL: course.VideoUrl,
              FILE_TYPE: 1,
              STATUS: 1,
              CASH_AMT: item.CashAmt,
              OTHER_AMT: item.GemAmt,
              GEM_AMT: item.GemAmt,
              TIMESTAMPS: []
            }))
          };

          if (isAdvanced) {
            advModules.push(mappedModule);
          } else {
            modules.push(mappedModule);
          }
        } else {
          const mappedVideo = {
            UID: item.Uid,
            ID: item.Uid,
            TITLE: item.Title,
            COURSE_DESC: item.CourseDesc,
            MASTER_NAME: item.MasterName,
            LEARNING_OBJECTIVES: item.LearningObjectives,
            SKILLS_COVERED: item.SkillsCovered,
            VIDEO_URL: item.VideoUrl,
            FILE_TYPE: 1,
            STATUS: 1,
            CASH_AMT: item.CashAmt,
            OTHER_AMT: item.GemAmt,
            GEM_AMT: item.GemAmt,
            ACCESS: item.Access === 1 || item.UserAccess === "True" || item.UserAccess === true ? 1 : 0,
            USER_ACCESS: item.UserAccess,
            TIMESTAMPS: []
          };

          if (isAdvanced) {
            advIndividualVideos.push(mappedVideo);
          } else {
            individualVideos.push(mappedVideo);
          }
        }
      });

      // Fetch advance courses endpoint and merge results into advanced lists
      try {
        const advResp = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Course/GetAdvanceCourses?CustId=${ID}&LangId=${langId}`);
        const advData = await advResp.json();
        console.log('Fetched advance courses:', advData);

        advData.forEach((item) => {
          // Treat everything from this endpoint as advanced
          if (item.Courses && item.Courses.length > 0) {
            const mappedModule = {
              UID: item.Uid,
              TITLE: item.Title,
              COURSE_DESC: item.CourseDesc,
              MASTER_NAME: item.MasterName,
              LEARNING_OBJECTIVES: item.LearningObjectives,
              SKILLS_COVERED: item.SkillsCovered,
              CASH_AMT: item.CashAmt,
              GEM_AMT: item.GemAmt,
              OTHER_AMT: item.GemAmt,
              ACCESS: item.Access === 1 || item.UserAccess === "True" || item.UserAccess === true ? 1 : 0,
              USER_ACCESS: item.UserAccess,
              COURSES: item.Courses.map((course) => ({
                HUID: course.Huid,
                SEQ: course.Seq,
                ID: course.Seq,
                UID: course.Uid,
                TITLE: course.Title,
                COURSE_DESC: course.CourseDesc,
                MASTER_NAME: course.MasterName,
                LEARNING_OBJECTIVES: course.LearningObjectives,
                SKILLS_COVERED: course.SkillsCovered,
                VIDEO_URL: course.VideoUrl,
                FILE_TYPE: 1,
                STATUS: 1,
                CASH_AMT: item.CashAmt,
                OTHER_AMT: item.GemAmt,
                GEM_AMT: item.GemAmt,
                TIMESTAMPS: []
              }))
            };
            advModules.push(mappedModule);
          } else {
            const mappedVideo = {
              UID: item.Uid,
              ID: item.Uid,
              TITLE: item.Title,
              COURSE_DESC: item.CourseDesc,
              MASTER_NAME: item.MasterName,
              LEARNING_OBJECTIVES: item.LearningObjectives,
              SKILLS_COVERED: item.SkillsCovered,
              VIDEO_URL: item.VideoUrl,
              FILE_TYPE: 1,
              STATUS: 1,
              CASH_AMT: item.CashAmt,
              OTHER_AMT: item.GemAmt,
              GEM_AMT: item.GemAmt,
              ACCESS: item.Access === 1 || item.UserAccess === "True" || item.UserAccess === true ? 1 : 0,
              USER_ACCESS: item.UserAccess,
              TIMESTAMPS: []
            };
            advIndividualVideos.push(mappedVideo);
          }
        });
      } catch (advErr) {
        console.warn('Failed to fetch advance courses:', advErr);
      }

      // Log the mapped return for debugging
      console.log('fetchPaidCourses mapped result:', {
        paidModules: modules,
        paidVideos: individualVideos,
        advancedModules: advModules,
        advancedVideos: advIndividualVideos,
      });

      // Clear and set the states completely
      setPaidModules(modules);
      setAdvancedModules(advModules);
      setCoursesVideos(prev => ({
        free: prev.free, // Keep free courses as they are
        paid: individualVideos, // Completely replace paid videos
        advanced: advIndividualVideos
      }));
    } catch (error) {
      console.error("Error fetching paid courses:", error);
      // On error, clear paid data
      setPaidModules([]);
      setAdvancedModules([]);
      setCoursesVideos(prev => ({
        free: prev.free,
        paid: [],
        advanced: []
      }));
    }
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        // Get language ID from localStorage, default to 2224 (English)
        const langId = localStorage.getItem('languageId') || '2224';
        
        // Fetch free courses from the new endpoint with LangId parameter
        const freeResponse = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Course/GetFreeCourses?LangId=${langId}`);
        const freeApiData = await freeResponse.json();

        // Map the new API response to the expected structure
        const freeCourses = freeApiData.map((course) => ({
          ID: course.Seq,
          UID: course.Uid,
          TITLE: course.Title,
          COURSE_DESC: course.CourseDesc,
          MASTER_NAME: course.MasterName,
          LEARNING_OBJECTIVES: course.LearningObjectives,
          SKILLS_COVERED: course.SkillsCovered,
          VIDEO_URL: course.VideoUrl,
          FILE_TYPE: 0,
          STATUS: 0,
          CASH_AMT: 0,
          OTHER_AMT: 0,
          TIMESTAMPS: []
        }));

        setCoursesVideos({
          free: freeCourses,
          paid: [], // Start with empty paid array
          advanced: []
        });
        
        // Clear paid/advanced modules on initial load
        setPaidModules([]);
        setAdvancedModules([]);
      } catch (error) {
        console.error("Error fetching course data:", error);
        // Set default empty state on error
        setCoursesVideos({
          free: [],
          paid: [],
          advanced: []
        });
        setPaidModules([]);
        setAdvancedModules([]);
      }
    };

    fetchCourses();
    //fetchPaidCourses(); // Fetch paid courses on mount
    
    // Check if user just made a purchase
    const justPurchased = localStorage.getItem('justPurchasedCourse');
    const purchasedModuleUID = localStorage.getItem('purchasedModuleUID');
    
    if (justPurchased === 'true') {
      // Switch to paid tab
      setActiveTab('paid');
      
      // Clear the flags
      localStorage.removeItem('justPurchasedCourse');
      
      // If we have a module UID, select it and show its courses
      if (purchasedModuleUID) {
        setTimeout(() => {
          const module = paidModules.find(m => m.UID === purchasedModuleUID);
          if (module && module.ACCESS === 1) {
            setSelectedModule(module);
            setShowModuleList(false);
          }
          localStorage.removeItem('purchasedModuleUID');
        }, 100);
      }
    }
  }, []);

  // determine affiliate/partner status using API (preferred) with localStorage fallback
  useEffect(() => {
    const checkProfileForAP = async () => {
      const userName = localStorage.getItem('username');
      const userID = localStorage.getItem('userID');
      const langId = localStorage.getItem('languageId') || '2224';

      // localStorage fallback flags
      const partnerId = localStorage.getItem('partnerCustId');
      const isAPFlag = localStorage.getItem('isAP') || localStorage.getItem('isAffiliate') || localStorage.getItem('isPartner') || localStorage.getItem('affiliate') || localStorage.getItem('partner');

      try {
        const resp = await fetch('https://xianhefairy.com/LotusFairy_API/api/User/GetProfile', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            UserName: userName,
            ID: userID,
            LangId: parseInt(langId),
            UserToken: '',
            Token: { AccessToken: 'xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp' }
          })
        });

        const result = await resp.json();
        const profile = result?.Profiles?.[0];
        console.log('Courses: profile (from GetProfile):', profile);

        // Heuristic checks for AP/affiliate flags in profile response
        let apiDetect = false;
        if (profile) {
          // Explicit AP/affiliate boolean fields
          if (profile.IsAP === true || profile.Is_AP === 1 || profile.AP === 1 || profile.IsAffiliate === true) apiDetect = true;
          // Role / MemberType string fields
          if (!apiDetect && profile.Role && /affiliate|partner|ap/i.test(profile.Role)) apiDetect = true;
          if (!apiDetect && profile.MemberType && /affiliate|partner|ap/i.test(profile.MemberType)) apiDetect = true;
          // VP_CODE / VVP_CODE — common AP marker in this system
          if (!apiDetect && profile.VP_CODE && /ap/i.test(String(profile.VP_CODE))) apiDetect = true;
          if (!apiDetect && profile.VVP_CODE && /ap/i.test(String(profile.VVP_CODE))) apiDetect = true;
          if (!apiDetect && profile.UPLINE_VP_CODE && /ap/i.test(String(profile.UPLINE_VP_CODE))) apiDetect = true;
          if (!apiDetect && profile.AletaMemberNo && String(profile.AletaMemberNo).trim() !== '') apiDetect = true;
        }

        // Any logged-in user with a valid profile is allowed to see the Advanced tab;
        // actual content access is controlled server-side.
        const hasValidProfile = Boolean(profile);
        const detected = Boolean(partnerId || isAPFlag || apiDetect || hasValidProfile);
        console.log('Courses: profile keys=', profile ? Object.keys(profile) : 'null', 'VP_CODE=', profile?.VP_CODE, 'VVP_CODE=', profile?.VVP_CODE, 'apiDetect=', apiDetect, 'finalAffiliate=', detected);
        setIsAffiliate(detected);
        setUserProfile(profile || null);

        // if API returned a partner cust id, store it for other flows
        if (profile && profile.CustId && !localStorage.getItem('partnerCustId')) {
          localStorage.setItem('partnerCustId', profile.CustId);
        }
      } catch (err) {
        console.error('Courses: error fetching profile for AP detection', err);
        // fallback to localStorage
        const partnerId = localStorage.getItem('partnerCustId');
        const isAPFlag = localStorage.getItem('isAP') || localStorage.getItem('isAffiliate') || localStorage.getItem('isPartner') || localStorage.getItem('affiliate') || localStorage.getItem('partner');
        setIsAffiliate(Boolean(partnerId || isAPFlag));
        setUserProfile(null);
      }
    };

    checkProfileForAP();
  }, []);

  // Add this new useEffect after the fetchCourses useEffect
  useEffect(() => {
    if (activeTab === 'paid' || activeTab === 'advanced') {
      // Clear selected states when switching to paid tab
      setShowModuleList(true);
      setSelectedModule(null);
      setSelectedCourse(null);
      
      // Clear existing paid data first to ensure clean state
      setPaidModules([]);
      setAdvancedModules([]);
      setCoursesVideos(prev => ({
        ...prev,
        paid: [],
        advanced: []
      }));
      
      // Then fetch fresh paid courses
      setTimeout(() => {
        fetchPaidCourses();
      }, 50); // Small delay to ensure state is cleared first
    } else if (activeTab === 'free') {
      // Clear paid-specific states when switching to free tab
      setSelectedModule(null);
      setSelectedCourse(null);
      setShowModuleList(true);
      
      // Clear paid data when leaving paid tab
      setPaidModules([]);
      setAdvancedModules([]);
      setCoursesVideos(prev => ({
        ...prev,
        paid: [],
        advanced: []
      }));
    }
  }, [activeTab]);

  // derive whether the user has VP/VVP codes (used to show Advanced tab)
  const hasCodes = !!(userProfile?.VVP_CODE || userProfile?.VP_CODE);

  useEffect(() => {
    if (!hasCodes && activeTab === 'advanced') {
      setActiveTab('free');
    }
  }, [hasCodes, activeTab]);

  const fetchTimestamps = async (courseUID) => {
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/CourseTimestamps?VUID=${courseUID}`
      );
      const data = await response.json();

      // Handle the actual API response structure
      return data
        .map((timestamp) => ({
          label: timestamp.TITLE || `Chapter ${timestamp.ID}`,
          time: convertTimestampToSeconds(timestamp.TIMESTAMP) || 0,
        }))
        .sort((a, b) => a.time - b.time); // Add this line to sort by time in ascending order
    } catch (error) {
      console.error("Error fetching timestamps:", error);
      return [];
    }
  };

  // Helper function to convert timestamp string to seconds
  // const convertTimestampToSeconds = (timestamp) => {
  //   if (!timestamp) return 0;

  //   // Handle format "00:00:09" (HH:MM:SS)
  //   const parts = timestamp.split(':');
  //   if (parts.length === 3) {
  //     const hours = parseInt(parts[0]) || 0;
  //     const minutes = parseInt(parts[1]) || 0;
  //     const seconds = parseInt(parts[2]) || 0;
  //     return hours * 3600 + minutes * 60 + seconds;
  //   }

  //   // Handle other formats or return 0
  //   return 0;
  // };

  // ✅ Helper function to convert timestamp string to seconds
  const convertTimestampToSeconds = (timestamp) => {
    if (!timestamp) return 0;

    const parts = timestamp.split(":").map((p) => parseInt(p) || 0);

    if (parts.length === 3) {
      // HH:MM:SS
      const [hours, minutes, seconds] = parts;
      return hours * 3600 + minutes * 60 + seconds;
    } else if (parts.length === 2) {
      // MM:SS (no hours)
      const [minutes, seconds] = parts;
      return minutes * 60 + seconds;
    }

    return 0; // fallback for unsupported formats
  };

  //test
  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     try {
  //       const response = await fetch(`${domain}getCF`);
  //       const apiData = await response.json();

  //       const freeCourses = apiData.filter((course) => course.FILE_TYPE === 0);
  //       const paidCourses = apiData.filter((course) => course.FILE_TYPE === 1);

  //       // Add a test video for development
  //       const testVideo1 = {
  //         ID: 999,
  //         TITLE: "Test Video",
  //         FILENAME: "test-video1.mp4",
  //         FILE_TYPE: 0,
  //         COURSE_DESC: "This is a test video for development",
  //         CASH_AMT: 0,
  //         OTHER_AMT: 0,
  //         STATUS: 0,
  //         TIMESTAMPS: [
  //           { label: "Introduction", time: 0 },
  //           { label: "Main Content", time: 30 },
  //           { label: "Key Points", time: 60 },
  //           { label: "Conclusion", time: 90 }
  //         ]
  //       };

  //       const testVideo2 = {
  //         ID: 998,
  //         TITLE: "Test Video 2",
  //         FILENAME: "test-video2.mp4", // You can use the same video file or a different one
  //         FILE_TYPE: 0,
  //         COURSE_DESC: "This is the second test video for development",
  //         CASH_AMT: 0,
  //         OTHER_AMT: 0,
  //         STATUS: 0,
  //         TIMESTAMPS: [
  //           { label: "Welcome", time: 0 },
  //           { label: "Chapter 1", time: 10 },
  //           { label: "Chapter 2", time: 20 },
  //           { label: "Summary", time: 30 }
  //         ]
  //       };

  //       setCoursesVideos({
  //         free: [...freeCourses, testVideo1, testVideo2],
  //         paid: paidCourses,
  //       });
  //     } catch (error) {
  //       console.error("Error fetching course data:", error);
  //       // Fallback to test data if API fails
  //       const testVideo1 = {
  //         ID: 999,
  //         TITLE: "Test Video",
  //         FILENAME: "test-video1.mp4",
  //         FILE_TYPE: 0,
  //         COURSE_DESC: "This is a test video for development",
  //         CASH_AMT: 0,
  //         OTHER_AMT: 0,
  //         STATUS: 0,
  //         TIMESTAMPS: []
  //       };

  //       const testVideo2 = {
  //         ID: 998,
  //         TITLE: "Test Video 2",
  //         FILENAME: "test-video2.mp4",
  //         FILE_TYPE: 0,
  //         COURSE_DESC: "This is the second test video for development",
  //         CASH_AMT: 0,
  //         OTHER_AMT: 0,
  //         STATUS: 0,
  //         TIMESTAMPS: [
  //           { label: "Welcome", time: 0 },
  //           { label: "Chapter 1", time: 45 },
  //           { label: "Chapter 2", time: 120 },
  //           { label: "Summary", time: 180 }
  //         ]
  //       };
  //       setCoursesVideos({
  //         free: [testVideo1, testVideo2],
  //         paid: [],
  //       });
  //     }
  //   };

  //   fetchCourses();
  // }, []);

  useEffect(() => {
    const fetchPurchasedCourses = async () => {
      try {
        const response = await fetch(`${domain}getUserPuchased?ID=${ID}`);
        const data = await response.json();
        console.log("Purchased Courses:", data);
        // Store titles and IDs (as strings) so we can match by title or id
        const entries = [];
        data.forEach((c) => {
          if (c && c.TITLE) entries.push(c.TITLE);
          if (c && (c.ID || c.Id || c.Idx)) entries.push(String(c.ID || c.Id || c.Idx));
          if (c && c.UID) entries.push(String(c.UID));
        });
        setPurchasedCourses(entries);
      } catch (error) {
        console.error("Error fetching purchased courses:", error);
      }
    };

    fetchPurchasedCourses();
  }, []);

  const isCoursePurchased = useCallback((course) => {
    if (!course) return false;
    // Prioritize UID matching (most reliable), then title, then ID
    const checks = [
      course.UID && String(course.UID),
      course.TITLE,
      course.ID && String(course.ID),
    ].filter(Boolean);

    return checks.some((val) => purchasedCourses.includes(val));
  }, [purchasedCourses]);

  // const getVideoSrc = (course) => {
  //   return course.STATUS === 0
  //     ? `/static/media/video/free/${course.FILENAME}`
  //     : `/static/media/video/paid/${course.FILENAME}`;
  // };

  const getVideoSrc = useCallback((course) => {
    // If VIDEO_URL is already set (from the new API), use it directly
    if (course.VIDEO_URL) {
      return course.VIDEO_URL;
    }

    // Fallback to old logic for backward compatibility
    return course.STATUS === 0
      ? `/static/media/video/free/${course.FILENAME}`
      : `/static/media/video/paid/${course.FILENAME}`;
  }, []);

  // const getVideoSrc = useCallback((course) => {
  //   // For test videos, use public folder
  //   // if (course.ID === 999 || course.ID === 998) {
  //   //   return `/test-videos/${course.FILENAME}`;
  //   // }

  //   return course.STATUS === 0
  //     ? `/static/media/video/free/${course.FILENAME}`
  //     : `/static/media/video/paid/${course.FILENAME}`;
  // }, []);
  const fetchData = async () => {
    const url = `${domain}getTotal?ID=${ID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("this is data", data);

      if (Array.isArray(data) && data.length > 0) {
        setCurrentCoins(data[0].COINS);
        return data[0].COINS; // Return the value for immediate use
      } else {
        console.warn("API returned unexpected data:", data);
        setCurrentCoins(0);
        return 0;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return 0;
    }
  };

  const fetchComs = async () => {
    const url = `${domain}getTotalCommission?ID=${ID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("Commission data:", data);

      // Assuming data is an object like { COINS: 123 }
      setCurrentComCoins(data.COINS || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Move your log inside a useEffect to track updates:
  useEffect(() => {
    console.log("Updated coins:", currentCoins, currentComCoins);
  }, [currentCoins, currentComCoins]);

  useEffect(() => {
    fetchData();
    fetchComs();
  }, []);

  const [selectedCourseCashAmt, setSelectedCourseCashAmt] = useState(null);

  // Legacy handlePurchase removed; using postPayCourse directly in handlePayment

  // Legacy handlePurchaseCommission removed; using postPayCourse directly

  const postPayCourse = async (course, payMode) => {
    const apiUrl =
      "https://xianhefairy.com/LotusFairy_API/api/member/postPayCourse";
    const normalizedPayMode = (payMode === 1 || String(payMode) === "1") ? 1 : 0;
    
    console.log("=== postPayCourse CALLED ===");
    console.log("Pay Mode:", payMode, "→ Normalized:", normalizedPayMode);
    console.log("Course UID:", course.UID);
    console.log("Course Title:", course.TITLE);
    console.log("CASH_AMT:", course.CASH_AMT);
    console.log("OTHER_AMT (Gems):", course.OTHER_AMT);
    console.log("GEM_AMT:", course.GEM_AMT);
    console.log("Full course object:", course);
    
    const data = {
      UID: "",
      Title: course.TITLE,
      CUID: course.HUID,
      CustomerID: ID,
      Stat: 1,
      CreatedBy: ID, 
      UpdatedBy: "web-user",
      PREFIX: "PC",
      PAY_MODE: normalizedPayMode,
    };

    console.log("=== PAYLOAD BEING SENT ===");
    console.log("postPayCourse payload:", data);

    try {
      console.log("postPayCourse payload:", data);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("postPayCourse API response:", result);

      if (result.success === false || result.error || result.status === 'error') {
        console.error("❌ Payment API returned error:", result);
        return false;
      }

      if (result.message === "Paid log entry updated successfully" && !result.gemsDeducted) {
        console.warn("⚠️ Payment logged but gems may not have been deducted");
      }

      console.log("✅ postPayCourse successful:", result);
      return true;
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };

  // Use postPayCourse directly for card
  const handlePurchasebyCard = async () => {
    try {
      const activated = await postPayCourse(selectedCourse, 1);
      if (activated) {
        // Re-fetch paid courses with updated access status
        await fetchPaidCourses();
        
        // Re-fetch coins to show updated balance
        await fetchData();
        
        // Store that we just made a payment so we can switch to paid tab
        localStorage.setItem('justPurchasedCourse', 'true');
        localStorage.setItem('purchasedModuleUID', selectedCourse.UID);
        
        setHandlePaymentSuccess(true);
        setMessage('Payment successful. Course unlocked.');
        setModalOpen(false);
        setTimeout(() => window.location.reload(), 800);
        return true;
      }
      alert('Purchase failed. Please try again later.');
      return false;
    } catch (error) {
      console.log(`Error: ${error.message}`);
      return false;
    }
  };

  // (old handlePurchasebyCard removed; new version defined below using postPayCourse directly)

  const openModal = async (course) => {
    // Check if user is logged in
    if (!isLoggedIn) {
      openRightSignIn();
      return;
    }

    if (isLoggedIn) {
      setSelectedCourseCashAmt(course.CASH_AMT);

      console.log("=== OPENING MODAL FOR COURSE ===");
      console.log("Course Title:", course.TITLE);
      console.log("Course UID:", course.UID);
      console.log("Course ID:", course.ID);
      console.log("Course ACCESS:", course.ACCESS);
      console.log("Full course object:", course);

      let courseWithTimestamps = course;

      // ✅ FETCH PDF FILES USING COURSE UID
      if (course.UID && course.UID.trim() !== '') {
        try {
          console.log("=== FETCHING PDF FILES ===");
          console.log("Using UID:", course.UID);
          
          const pdfResponse = await fetch(`https://xianhefairy.com/LotusFairy_API/api/member/get-pdf-list?UID=${course.UID}`);
          const pdfData = await pdfResponse.json();
          
          console.log("=== FETCHED PDF DATA ===");
          console.log("PDF Response:", pdfData);
          
          if (pdfData && pdfData.files && Array.isArray(pdfData.files) && pdfData.files.length > 0) {
            const pdfFiles = pdfData.files.map(pdf => ({
              name: pdf.name || 'Course Material',
              url: pdf.url
            }));
            
            const validPdfFiles = pdfFiles.filter(file => file.url && file.url.trim() !== '');
            
            courseWithTimestamps = {
              ...courseWithTimestamps,
              PDF_FILES: validPdfFiles
            };
            
            console.log("✅ PDF files attached to course:", validPdfFiles);
          } else if (Array.isArray(pdfData) && pdfData.length > 0) {
            // Fallback: if pdfData is directly an array
            const pdfFiles = pdfData.map(pdf => ({
              name: pdf.name || pdf.Name || 'Course Material',
              url: pdf.url || pdf.Url
            }));
            
            const validPdfFiles = pdfFiles.filter(file => file.url && file.url.trim() !== '');
            
            courseWithTimestamps = {
              ...courseWithTimestamps,
              PDF_FILES: validPdfFiles
            };
            
            console.log("✅ PDF files attached to course:", validPdfFiles);
          } else {
            console.log("ℹ️ No PDF files found for this course");
            courseWithTimestamps = {
              ...courseWithTimestamps,
              PDF_FILES: []
            };
          }
        } catch (error) {
          console.error("❌ Failed to fetch PDF files:", error);
          courseWithTimestamps = {
            ...courseWithTimestamps,
            PDF_FILES: []
          };
        }
      } else {
        console.log("⚠️ No UID available for PDF fetch");
        courseWithTimestamps = {
          ...courseWithTimestamps,
          PDF_FILES: []
        };
      }

      // Fetch timestamps
      if (course.UID && course.UID.trim() !== '' && course.ID !== 999 && course.ID !== 998) {
        console.log("=== FETCHING TIMESTAMPS ===");
        console.log("UID being used:", course.UID);
        
        setLoadingTimestamps(true);
        try {
          const timestamps = await fetchTimestamps(course.UID);
          console.log("Fetched timestamps:", timestamps);
          
          courseWithTimestamps = {
            ...courseWithTimestamps,
            TIMESTAMPS: timestamps,
          };
        } catch (error) {
          console.error("Failed to fetch timestamps:", error);
        }
        setLoadingTimestamps(false);
      }
      
      console.log("=== SETTING SELECTED COURSE ===");
      console.log("Final course object:", courseWithTimestamps);
      console.log("PDF_FILES in final object:", courseWithTimestamps.PDF_FILES);
      
      setSelectedCourse(courseWithTimestamps);
      
      const isPartOfPurchasedModule = selectedModule && selectedModule.ACCESS === 1;
      const hasAccess = course.ACCESS === 1 || 
                      course.FILE_TYPE === 0 || 
                      isCoursePurchased(course) || 
                      isPartOfPurchasedModule;
      
      console.log("=== ACCESS CHECK ===");
      console.log("course.ACCESS:", course.ACCESS);
      console.log("course.FILE_TYPE:", course.FILE_TYPE);
      console.log("isCoursePurchased:", isCoursePurchased(course));
      console.log("isPartOfPurchasedModule:", isPartOfPurchasedModule);
      console.log("hasAccess:", hasAccess);
      
      if (hasAccess) {
        setIsModalOpen(true);
        console.log("✅ Opening modal for purchased/free course");
      } else {
        setShowPaymentModal(true);
        console.log(" Opening payment modal for locked course");
      }
    } else {
      // navigate("/main");
      //alert("you need to login first");
    }
  };

  useEffect(() => {
    if (selectedCourse) {
      console.log("=== SELECTED COURSE CHANGED ===");
      console.log("selectedCourse.TITLE:", selectedCourse.TITLE);
      console.log("selectedCourse.PDF_FILES:", selectedCourse.PDF_FILES);
      console.log("PDF_FILES length:", selectedCourse.PDF_FILES?.length);
    }
  }, [selectedCourse]);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCourse(null);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedCourse(null);
  };

  const handlePayment = async () => {
    // Prevent double execution
    if (isGemPaymentLoading) {
      console.log("Payment already in progress, ignoring...");
      return;
    }
    
    setIsGemPaymentLoading(true);
    
    try {
      // Fetch latest gem count and get the returned value directly
      const latestCoins = await fetchData();
      
      const requiredGems = selectedCourse?.OTHER_AMT || selectedCourse?.GEM_AMT || 0;
    
      console.log("=== handlePayment CALLED ===");
      console.log("Selected Course:", selectedCourse);
      console.log("Required Gems:", requiredGems);
      console.log("Latest Coins (from API):", latestCoins);
      
      if (requiredGems > latestCoins) {
        console.log("❌ Insufficient gems:", requiredGems, ">", latestCoins);
        setInsufficientGemsModal({ show: true, required: requiredGems, current: latestCoins });
        return;
      }

      console.log("✅ Sufficient gems, proceeding with payment...");

      const courseToPayFor = selectedCourse;
      const ok = await postPayCourse(courseToPayFor, 0); // 0 = gem
      
      if (ok) {
        try {
          const response = await fetch(`${domain}getUserPuchased?ID=${ID}`);
          const data = await response.json();
          const entries = [];
          data.forEach((c) => {
            if (c && c.TITLE) entries.push(c.TITLE);
            if (c && (c.ID || c.Id || c.Idx)) entries.push(String(c.ID || c.Id || c.Idx));
            if (c && c.UID) entries.push(String(c.UID));
          });
          setPurchasedCourses(entries);
        
          await fetchData();
          await fetchPaidCourses();
        
          localStorage.setItem('justPurchasedCourse', 'true');
          localStorage.setItem('purchasedModuleUID', courseToPayFor.UID);
          
        } catch (err) {
          console.error('Post-purchase actions failed', err);
        }
        closeConfirmationModal();
        setShowPaymentModal(false);
      } else {
        alert('Purchase failed. Please try again later.');
      }
    } finally {
      setIsGemPaymentLoading(false);
    }
  };

  //stripe
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [stripecost, setStripeCost] = useState();
  const [guardianModal, setGuardianModal] = useState({ show: false, pendingCost: null });
  const userAgeRef = useRef(undefined);

  const fetchUserAge = async () => {
    if (userAgeRef.current !== undefined) return userAgeRef.current;
    try {
      const res = await fetch("https://xianhefairy.com/LotusFairy_API/api/User/GetProfile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UserName: localStorage.getItem("username") || "",
          ID: parseInt(ID || "0", 10),
          LangId: parseInt(localStorage.getItem("languageId") || "2224", 10) || 2224,
          UserToken: "",
          Token: { AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp" },
        }),
      });
      if (!res.ok) { userAgeRef.current = null; return null; }
      const data = await res.json();
      const age = data?.Profiles?.[0]?.Age ?? null;
      userAgeRef.current = age;
      return age;
    } catch {
      userAgeRef.current = null;
      return null;
    }
  };

  const openStripeModal = async (cost) => {
    const age = await fetchUserAge();
    if (age !== null && age < 18) {
      setGuardianModal({ show: true, pendingCost: cost });
    } else {
      setStripeCost(cost);
      setIsConfirmationModalOpen(false);
      setModalOpen(true);
      setIsModalOpen(false);
    }
  };

  const closeStripeModal = () => {
    setModalOpen(false);
  };

  // const handlePaymentSuccess = (paymentIntent) => {
  //   handlePurchasebyCard();
  //   alert("Payment was successful!");
  //   postPayCourse(selectedCourse);
  // };

  const handleTimestampClick = useCallback((time) => {
    if (videoRef.current) {
      videoRef.current.currentTime = time;
      videoRef.current.play().catch((err) => {
        console.warn("Autoplay prevented:", err);
      });
    }
  }, []);

 
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      if (selectedCourse?.VIDEO_URL) {
        videoRef.current.load(); // Force reload when course changes
      }
    }
  }, [selectedCourse?.VIDEO_URL]); // Watch VIDEO_URL specifically


  const activeCourses = useMemo(() => {
    const sortCourses = (list) =>
      [...list].sort((a, b) => {
        const titleA = (a.TITLE || "").trim();
        const titleB = (b.TITLE || "").trim();
        const numA = parseFloat(titleA);
        const numB = parseFloat(titleB);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: "base" });
      });

    if (activeTab === "free") {
      return sortCourses(coursesvideos.free);
    } else if (activeTab === "paid") {
      // Always show modules and individual videos together
      return sortCourses([...paidModules, ...coursesvideos.paid]);
    } else if (activeTab === "advanced") {
      // For advanced tab (affiliate-only). Ensure user is both logged in and an affiliate (AP).
      if (!(isAffiliate && isLoggedIn)) return [];
      return sortCourses([...advancedModules, ...coursesvideos.advanced]);
    }
    return []; // Add default return
  }, [activeTab, coursesvideos.free, coursesvideos.paid, coursesvideos.advanced, paidModules, advancedModules, isAffiliate, isLoggedIn]);


  return (
  <div ref={pageRootRef} style={{ minHeight: '100vh', background: '#111', fontFamily: 'Segoe UI, Arial, sans-serif', color: '#fff' }}>
      <style>{`
        .ll-sidebar {
          background: #1c1c1c;
          border-right: 1px solid #333;
          min-width: 320px;
          max-width: 340px;
          width: 100%;
          height: 100vh;
          overflow-y: auto;
          box-shadow: 2px 0 8px rgba(0,0,0,0.12);
          padding: 0;
          transition: transform .3s cubic-bezier(.4,0,.2,1);
        }
        .ll-sidebar-header {
          padding: 24px 24px 12px 24px;
          font-size: 1.3rem;
          font-weight: 700;
          color: #DFBD69;
          background: #1c1c1c;
          border-bottom: 1px solid #333;
        }
        .ll-sidebar-tabs {
          display: flex;
          gap: 0;
          border-bottom: 1px solid #333;
        }
        .ll-sidebar-tabs button {
          flex: 1;
          padding: 14px 0;
          background: none;
          border: none;
          font-size: 1rem;
          font-weight: 600;
          color: #fff;
          border-bottom: 2px solid transparent;
          cursor: pointer;
          transition: color .2s, border-color .2s;
        }
        .ll-sidebar-tabs button.active {
          color: #DFBD69;
          border-bottom: 2px solid #DFBD69;
          background: #222;
        }
        .ll-course-list {
          padding: 0 0 24px 0;
        }
        .ll-course-item {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 12px 16px;
          border-bottom: 1px solid #222;
          cursor: pointer;
          background: #141414;
          transition: background .2s;
        }
        .ll-course-item.selected {
          background: #1a1a1a;
        }
        .ll-course-item:hover {
          background: #1f1f1f;
        }
        .ll-course-thumb {
          flex-shrink: 0;
          width: 130px;
          aspect-ratio: 16/9;
          background: #222;
          border-radius: 4px;
          overflow: hidden;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ll-course-thumb::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: #333;
        }
        .ll-course-item.selected .ll-course-thumb::after,
        .ll-course-item:hover .ll-course-thumb::after {
          background: #DFBD69;
        }
        .ll-course-meta {
          flex: 1;
          min-width: 0;
        }
        .ll-episode-label {
          font-size: 0.68rem;
          font-weight: 700;
          color: #DFBD69;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin: 0 0 3px 0;
        }
        .ll-course-title {
          font-size: 0.88rem;
          font-weight: 600;
          color: #fff;
          margin: 0 0 4px 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 1.35;
        }
        .ll-price-tag {
          font-size: 0.78rem;
          color: #DFBD69;
          font-weight: 600;
        }
        .ll-paid {
          color: #4caf50;
        }
        .ll-main {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          padding: 40px 0 0 0;
        }
        .ll-main-card {
          background: #181818;
          border-radius: 16px;
          box-shadow: 0 2px 16px rgba(0,0,0,0.18);
          margin: 0 auto 32px auto;
          max-width: 900px;
          width: 100%;
          padding: 32px 36px 36px 36px;
          display: flex;
          flex-direction: column;
          align-items: stretch;
        }
        .ll-main-title {
          font-size: 2rem;
          font-weight: 700;
          color: #DFBD69;
          margin-bottom: 18px;
          text-align: left;
        }
        .ll-main-instructor {
          font-size: 1.1rem;
          color: #fff;
          margin-bottom: 18px;
        }
        .ll-main-video {
          width: 100%;
          aspect-ratio: 16/9;
          background: #000;
          border-radius: 10px;
          overflow: hidden;
          margin-bottom: 28px;
        }
        .ll-main-tabs {
          display: flex;
          gap: 0;
          border-bottom: 1px solid #333;
          margin-bottom: 18px;
        }
        .ll-main-tabs button {
          flex: 1;
          padding: 14px 0;
          background: none;
          border: none;
          font-size: 1rem;
          font-weight: 600;
          color: #fff;
          border-bottom: 2px solid transparent;
          cursor: pointer;
          transition: color .2s, border-color .2s;
        }
        .ll-main-tabs button.active {
          color: #DFBD69;
          border-bottom: 2px solid #DFBD69;
          background: #222;
        }
        .ll-main-content {
          margin-top: 18px;
        }
        .ll-overview-section h3 {
          color: #DFBD69;
          font-size: 1.2rem;
          margin-bottom: 8px;
        }
        .ll-overview-section p {
          color: #ccc;
          font-size: 1rem;
          margin-bottom: 16px;
        }
        .ll-timestamps-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .ll-timestamp-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 0;
          border-bottom: 1px solid #333;
          cursor: pointer;
          color: #DFBD69;
          font-size: 1rem;
          transition: background .15s;
        }
        .ll-timestamp-item:hover {
          background: #222;
        }
        .ll-timestamp-time {
          font-weight: 600;
          color: #fff;
          min-width: 48px;
        }
        .ll-timestamp-label {
          color: #DFBD69;
        }
  @media (max-width: 900px) {
          .ll-sidebar { min-width: 100vw; max-width: 100vw; height: 320px; position: relative; }
          .ll-main { padding: 0; }
          .ll-main-card { max-width: 100vw; border-radius: 0; padding: 18px 8px 24px 8px; }
        }
        @media (max-width: 768px) {
          .ll-sidebar { position: fixed; z-index: 23000; top: 86px; left: 0; height: calc(100vh - 86px); height: calc(100dvh - 86px); overscroll-behavior: contain; transform: translateX(-110%); pointer-events: none; box-shadow: 4px 0 12px rgba(0,0,0,.18); border-radius: 0 0 12px 0; }
          .ll-sidebar.open { transform: translateX(0); pointer-events: auto; }
          .ll-sidebar-closer {
            position: absolute; top: 10px; right: 10px; background: #333; border: none; font-size: 1.4rem; color: #DFBD69; cursor: pointer; z-index: 23100; padding: 4px 10px; border-radius: 4px; }
          .ll-sidebar-toggle {
            display: block; position: fixed; top: 76px; left: 12px; z-index: 22500; background: #DFBD69; color: #111; border: none; padding: 10px 18px; font-size: 0.95rem; font-weight: 700; border-radius: 8px; box-shadow: 0 3px 8px rgba(0,0,0,.35); cursor: pointer; min-width: 110px; text-align: center; }
          .ll-main { padding-top: 60px !important; }
          .ll-backdrop { top: 86px !important; }
        }
        @media (min-width: 769px) {
          .ll-sidebar-toggle { display: none; }
        }
      `}</style>

      {/* Sidebar toggle for mobile (only show when sidebar is closed) */}
      {(isMobile || isTablet) && !isSidebarOpen && (
        <button
          className="ll-sidebar-toggle"
          onClick={() => setIsSidebarOpen(true)}
        >
          {t('courses.courses')}
        </button>
      )}

      {/* Backdrop — tap outside sidebar to close it */}
      {(isMobile || isTablet) && isSidebarOpen && (
        <div
          style={{ position: 'fixed', inset: 0, top: 86, background: 'rgba(0,0,0,0.5)', zIndex: 22999, touchAction: 'none' }}
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
          className="ll-backdrop"
        />
      )}
      {/* Header blocker — the layout's <main> is its own stacking context below the
          header, so this is portaled to <body> to sit over the header area */}
      {(isMobile || isTablet) && isSidebarOpen && createPortal(
        <div
          style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 86, background: 'rgba(0,0,0,0.5)', zIndex: 24000, touchAction: 'none' }}
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
        />,
        document.body
      )}

      <div style={{ display: 'flex', minHeight: '100vh' }}>
        {/* Sidebar */}
        <aside className={`ll-sidebar${(isMobile || isTablet) && isSidebarOpen ? ' open' : ''}`} aria-hidden={(isMobile || isTablet) && !isSidebarOpen}>
          {(isMobile || isTablet) && (
            <button className="ll-sidebar-closer" onClick={() => setIsSidebarOpen(false)} aria-label="Close sidebar">×</button>
          )}
          <div className="ll-sidebar-header">{t('courses.courses')}</div>
          <div className="ll-sidebar-tabs">
            <button className={activeTab === 'free' ? 'active' : ''} onClick={() => setActiveTab('free')}>{t('courses.free')}</button>
            <button className={activeTab === 'paid' ? 'active' : ''} onClick={() => setActiveTab('paid')}>{t('courses.paid')}</button>
            {(hasCodes && isLoggedIn) && (
              <button className={activeTab === 'advanced' ? 'active' : ''} onClick={() => setActiveTab('advanced')}>{t('courses.advanced')}</button>
            )}
          </div>
          <div className="ll-course-list" aria-label="Course list">
            {(activeTab === 'paid' || activeTab === 'advanced') ? (
              // Show modules with accordion-style inline lesson expansion
              activeCourses.map(item => {
                const hasAccess = item.ACCESS === 1;
                const hasVideoUrl = item.VIDEO_URL && item.VIDEO_URL.trim() !== '';
                const isModule = item.COURSES && item.COURSES.length > 0;
                const isExpanded = expandedModuleUIDs.has(item.UID);
                
                return (
                  <React.Fragment key={item.UID}>
                  <div
                    className={`ll-course-item${selectedModule?.UID === item.UID || selectedCourse?.UID === item.UID ? ' selected' : ''}`}
                    onClick={() => {
                    if (isModule) {
                      // Toggle expansion for all modules (locked or not)
                      if (hasAccess) setSelectedModule(item);
                      setExpandedModuleUIDs(prev => {
                        const next = new Set(prev);
                        if (next.has(item.UID)) next.delete(item.UID);
                        else next.add(item.UID);
                        return next;
                      });
                      if (hasAccess) setSelectedCourse(null);
                      // On mobile: keep sidebar open so user can pick a lesson inside the module
                    } else {
                      // ✅ This is a standalone paid video
                      setSelectedModule(null);
                      if (hasAccess) {
                        // User has access - open the video
                        openModal(item);
                      } else {
                        // User doesn't have access - require login before purchase
                        if (!isLoggedIn) { setSelectedCourse(item); if (isMobile || isTablet) setIsSidebarOpen(false); openRightSignIn(); return; }
                        setSelectedCourse(item);
                        openModal(item);
                        setShowPaymentModal(true);
                      }
                      if (isMobile || isTablet) setIsSidebarOpen(false);
                    }
                  }}
                    tabIndex={0}
                    role="button"
                    aria-pressed={selectedModule?.UID === item.UID || selectedCourse?.UID === item.UID}
                  >
                    <div className="ll-course-thumb" style={{ position: 'relative' }}>
                      {isModule ? (
                        <div style={{ 
                          width: '100%', 
                          height: '100%', 
                          background: hasAccess ? '#2e7d32' : '#222', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          fontSize: 10, 
                          color: hasAccess ? '#fff' : '#DFBD69', 
                          borderRadius: 4,
                          position: 'relative'
                        }}>
                          {hasAccess ? t('courses.ownedModule') : t('courses.lockedModule')}
                        </div>
                      ) : (
                        <>
                          {!isMobile ? (
                            <HoverVideoPlayer
                              videoSrc={item.VIDEO_URL}
                              style={{ width: '100%', height: '100%' }}
                              videoProps={{
                                controlsList: 'nodownload',
                                onContextMenu: (e) => e.preventDefault(),
                                disablePictureInPicture: true,
                                disableRemotePlayback: true,
                              }}
                            />
                          ) : (
                            <div style={{ width: '100%', height: '100%', background: '#222', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, color: hasAccess ? '#2e7d32' : '#DFBD69', borderRadius: 4 }}>
                              {hasAccess ? t('courses.ownedVideo') : t('courses.lockedVideo')}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className="ll-course-meta">
                      {/* {!isModule && <div className="ll-episode-label">{t('courses.lesson')} {String(activeCourses.indexOf(item) + 1).padStart(2, '0')}</div>} */}
                      {!isModule}
                      <div className="ll-course-title" title={item.TITLE}>{item.TITLE}</div>
                      {hasAccess ? (
                        <span className="ll-price-tag ll-paid">
                          {t('courses.purchased')}
                          {isModule && (
                            <span style={{ marginLeft: 6, fontSize: 10 }}>{isExpanded ? '▲' : '▼'}</span>
                          )}
                        </span>
                      ) : (
                        isModule && <span className="ll-price-tag">{format(convert(item.CASH_AMT))} | {item.GEM_AMT.toFixed(0)} {t('courses.gems')}</span>
                      )}
                    </div>
                  </div>
                  {isModule && isExpanded && item.COURSES && [...item.COURSES].sort((a, b) =>
                    (a.TITLE || '').localeCompare(b.TITLE || '', undefined, { numeric: true, sensitivity: 'base' })
                  ).map(course => (
                    <div
                      key={course.HUID || course.UID || `${item.UID}-${course.ID}`}
                      className={`ll-course-item${selectedCourse?.ID === course.ID ? ' selected' : ''}`}
                      style={{ paddingLeft: 24, borderLeft: '3px solid #DFBD69', background: selectedCourse?.ID === course.ID ? '#2a2a2a' : '#181818' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!hasAccess) {
                          if (!isLoggedIn) { setSelectedCourse(course); if (isMobile || isTablet) setIsSidebarOpen(false); openRightSignIn(); return; }
                          setSelectedCourse(course);
                          setShowPaymentModal(true);
                          return;
                        }
                        setSelectedCourse(course);
                        openModal(course);
                        if (isMobile || isTablet) setIsSidebarOpen(false);
                      }}
                      tabIndex={0}
                      role="button"
                      aria-pressed={selectedCourse?.ID === course.ID}
                    >
                      <div className="ll-course-thumb" onContextMenu={(e) => e.preventDefault()}>
                        {!isMobile ? (
                          <HoverVideoPlayer
                            videoSrc={getVideoSrc(course)}
                            style={{ width: '100%', height: '100%' }}
                            videoProps={{
                              controlsList: 'nodownload',
                              onContextMenu: (e) => e.preventDefault(),
                              disablePictureInPicture: true,
                              disableRemotePlayback: true,
                            }}
                          />
                        ) : (
                          <div style={{ width: '100%', height: '100%', background: '#222', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, color: '#aaa', borderRadius: 4 }}>{t('courses.video')}</div>
                        )}
                      </div>
                      <div className="ll-course-meta">
                        {/* <div className="ll-episode-label">{t('courses.lesson')} {String((course.SEQ || course.ID || 0)).padStart(2, '0')}</div> */}
                        <div className="ll-course-title" title={course.TITLE}>{course.TITLE}</div>
                      </div>
                    </div>
                  ))}
                  </React.Fragment>
                );
              })
            ) : (
              // Free courses (unchanged)
              activeCourses.map(course => {
                const purchased = isCoursePurchased(course);
                return (
                  <div
                    key={course.ID}
                    className={`ll-course-item${selectedCourse?.ID === course.ID ? ' selected' : ''}`}
                    onClick={() => {
                      setSelectedCourse(course);
                      if (!isLoggedIn) {
                        if (isMobile || isTablet) setIsSidebarOpen(false);
                        return;
                      }
                      if (course.CASH_AMT > 0) {
                        if (purchased) {
                          openModal(course);
                        } else {
                          openModal(course);
                          setShowPaymentModal(true);
                        }
                      } else {
                        openModal(course);
                      }
                      if (isMobile || isTablet) setIsSidebarOpen(false);
                    }}
                    tabIndex={0}
                    role="button"
                    aria-pressed={selectedCourse?.ID === course.ID}
                  >
                    <div className="ll-course-thumb" style={{ position: 'relative', opacity: isLoggedIn ? 1 : 0.5 }} onContextMenu={(e) => e.preventDefault()}>
                      {!isMobile ? (
                        <HoverVideoPlayer
                          videoSrc={getVideoSrc(course)}
                          style={{ width: '100%', height: '100%' }}
                          videoProps={{
                            controlsList: 'nodownload',
                            onContextMenu: (e) => e.preventDefault(),
                            disablePictureInPicture: true,
                            disableRemotePlayback: true,
                          }}
                        />
                      ) : (
                        <div style={{ width: '100%', height: '100%', background: '#e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, color: '#aaa', borderRadius: 4 }}>{t('courses.video')}</div>
                      )}
                      {!isLoggedIn && (
                        <div style={{ 
                          position: 'absolute', 
                          top: '50%', 
                          left: '50%', 
                          transform: 'translate(-50%, -50%)', 
                          fontSize: '30px', 
                          color: '#DFBD69' 
                        }}>
                          
                        </div>
                      )}
                    </div>
                    <div className="ll-course-meta">
                      {/* <div className="ll-episode-label">{t('courses.lesson')} {String(activeCourses.indexOf(course) + 1).padStart(2, '0')}</div> */}
                      <div className="ll-course-title" title={course.TITLE}>{course.TITLE}</div>
                      {course.CASH_AMT > 0 && (
                        purchased ? (
                          <span className="ll-price-tag ll-paid">{t('courses.purchased')}</span>
                        ) : (
                          <span className="ll-price-tag">{format(convert(course.CASH_AMT))} | {course.OTHER_AMT.toFixed(0)} {t('courses.gems')}</span>
                        )
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </aside>

        {/* Main Content */}
        <main className="ll-main">
          <div className="ll-main-card">
            {selectedCourse ? (
              <>
                <div className="ll-main-title">{selectedCourse.TITLE}</div>
                <div className="ll-main-instructor">{selectedCourse.MASTER_NAME ? `By ${selectedCourse.MASTER_NAME}` : ''}</div>
                <div className="ll-main-video" style={{ position: 'relative' }}>
                  {/* Determine access: paid courses require purchase */}
                  {(() => {
                    // Check if user is logged in first
                    if (!isLoggedIn) {
                      return (
                        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000', borderRadius: '10px', color: '#ccc', flexDirection: 'column', padding: 20 }}>
                          <div style={{ fontSize: 48, color: '#DFBD69', marginBottom: 12 }}></div>
                          <div style={{ fontSize: 18, fontWeight: 700, color: '#DFBD69', marginBottom: 8 }}>Sign In Required</div>
                          <div style={{ marginBottom: 16, textAlign: 'center', maxWidth: 560 }}>Please sign in to access course videos.</div>
                          <button
                            onClick={openRightSignIn}
                            style={{ background: '#DFBD69', color: '#111', border: 'none', borderRadius: 8, padding: '10px 16px', fontWeight: 'bold', cursor: 'pointer' }}
                          >
                            Sign In
                          </button>
                        </div>
                      );
                    }

                    const courseIsPaid = selectedCourse?.FILE_TYPE === 1;
                    // Check if user has module access OR course purchase
                    const hasModuleAccess = selectedModule?.ACCESS === 1;
                    const hasAccess = !courseIsPaid || isCoursePurchased(selectedCourse) || hasModuleAccess;
                    // If user has access, render the normal video player
                    if (hasAccess) {
                      return (
                        <video
                          ref={videoRef}
                          controls
                          controlsList="nodownload"
                          preload="metadata"
                          playsInline
                          onContextMenu={(e) => e.preventDefault()}
                          disablePictureInPicture
                          disableRemotePlayback
                          style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000', borderRadius: '10px' }}
                          key={selectedCourse?.VIDEO_URL}
                        >
                          <source src={selectedCourse?.VIDEO_URL} type="video/mp4" />
                          {t('courses.videoError')}
                        </video>
                      );
                    }

                    // If no access, render a locked placeholder and CTA to purchase
                    return (
                      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000', borderRadius: '10px', color: '#ccc', flexDirection: 'column', padding: 20 }}>
                        <div style={{ fontSize: 48, color: '#DFBD69', marginBottom: 12 }}></div>
                        <div style={{ fontSize: 18, fontWeight: 700, color: '#DFBD69', marginBottom: 8 }}>{t('courses.paidCourse')}</div>
                        <div style={{ marginBottom: 16, textAlign: 'center', maxWidth: 560 }}>{t('courses.paidCourseMessage')}</div>
                        {/* <div style={{ display: 'flex', gap: 12 }}>
                          <button
                            onClick={() => {
                              // Ensure selectedCourse is set and open the payment modal
                              setSelectedCourse(selectedCourse);
                              setShowPaymentModal(true);
                            }}
                            style={{ background: '#DFBD69', color: '#111', border: 'none', borderRadius: 8, padding: '10px 16px', fontWeight: 'bold', cursor: 'pointer' }}
                          >
                            {t('courses.buyThisCourse')} ({format(convert(selectedCourse?.CASH_AMT))})
                          </button>
                          <button
                            onClick={() => setSelectedCourse(null)}
                            style={{ background: 'transparent', color: '#DFBD69', border: '1px solid #DFBD69', borderRadius: 8, padding: '10px 16px', fontWeight: '600', cursor: 'pointer' }}
                          >
                            {t('courses.backToList')}
                          </button>
                        </div> */}
                      </div>
                    );
                  })()}
                </div>
                <div className="ll-main-tabs" role="tablist" aria-label="Course content tabs">
                  <button
                    className={activeTabVideo === 'overview' ? 'active' : ''}
                    role="tab"
                    aria-selected={activeTabVideo === 'overview'}
                    onClick={() => setActiveTabVideo('overview')}
                  >
                    {t('courses.overview')}
                  </button>
                  <button
                    className={activeTabVideo === 'timestamps' ? 'active' : ''}
                    role="tab"
                    aria-selected={activeTabVideo === 'timestamps'}
                    onClick={() => setActiveTabVideo('timestamps')}
                  >
                    {t('courses.timestamps')}
                  </button>
                </div>
                <div className="ll-main-content">
                  {activeTabVideo === 'overview' ? (
                    <div className="ll-overview-section">
                      <h3>{t('courses.coursesOverview')}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: (selectedCourse.COURSE_DESC || '').replace(/\r\n|\n/g, '<br>')
                        }}
                        style={{ marginBottom: '16px', color: '#ccc', fontSize: '1rem' }}
                      />
                      {selectedCourse.LEARNING_OBJECTIVES && (
                        <>
                          <h3>{t('courses.learningObjectives')}</h3>
                          <ul style={{ marginBottom: '16px', color: '#ccc', fontSize: '1rem', paddingLeft: '20px' }}>
                            {(selectedCourse.LEARNING_OBJECTIVES || '')
                              .split(/\r?\n/)
                              .map((line, idx) => line.trim())
                              .filter(line => line.length > 0)
                              .map((line, idx) => (
                                <li key={idx}>{line}</li>
                              ))}
                          </ul>
                        </>
                      )}
                      {selectedCourse.PDF_FILES && selectedCourse.PDF_FILES.length > 0 && (
                        <div style={{ marginBottom: '20px', color: '#ccc' }}>
                          <h3>{t('courses.coursePDFs')}</h3>
                          <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                            {selectedCourse.PDF_FILES.map((file, idx) => (
                              <li key={idx} style={{ marginBottom: '8px' }}>
                                <span style={{ fontWeight: 500, marginRight: 8 }}>{file.name}:</span>
                                <a
                                  href={file.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: '#dfbd69', textDecoration: 'underline', fontWeight: 600 }}
                                  onClick={() => {
                                    console.log('PDF LINK CLICKED:', file.name, file.url);
                                  }}
                                >
                                  {t('courses.viewPDF')}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      {loadingTimestamps ? (
                        <p style={{ color: '#0073b1' }}>{t('courses.loadingTimestamps')}</p>
                      ) : Array.isArray(selectedCourse.TIMESTAMPS) && selectedCourse.TIMESTAMPS.length > 0 ? (
                        <ul className="ll-timestamps-list">
                          {selectedCourse.TIMESTAMPS.map((ts, idx) => (
                            <li
                              key={idx}
                              className="ll-timestamp-item"
                              onClick={() => handleTimestampClick(ts.time)}
                            >
                              <span className="ll-timestamp-time">{formatTime(ts.time)}</span>
                              <span className="ll-timestamp-label">{ts.label}</span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p style={{ color: '#888' }}>{t('courses.noTimestamps')}</p>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div style={{ color: '#888', textAlign: 'center', fontSize: '1.2rem', margin: '60px 0' }}>
                {isMobile
                ? t('courses.courseMessageMobile')
                : t('courses.courseMessage')}
              </div>
            )}
          </div>
        </main>
      </div>

      {/* Payment modal (unchanged) */}
      {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowPaymentModal(false)}
        >
          <div
            style={{
              backgroundColor: "#1a1a1a",
              padding: "32px 28px 24px 28px",
              borderRadius: "15px",
              width: "400px",
              maxWidth: "90vw",
              color: "#DFBD69",
              position: "relative",
              boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowPaymentModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                color: "#DFBD69",
                fontSize: "1.8rem",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 2,
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h2 style={{ color: "#DFBD69", marginBottom: "18px" }}>{t('courses.paymentConfirmation')}</h2>
            <div style={{ marginBottom: "18px", color: "#DFBD69", fontSize: "1.1em" }}>
              {t('courses.payMessage', { 
                cashAmt: format(convert(selectedCourse?.CASH_AMT)), 
                otherAmt: selectedCourse?.OTHER_AMT?.toFixed(0), 
                title: selectedCourse?.TITLE 
              })}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "14px", marginTop: "18px" }}>
              <button
                style={{
                  background: "#DFBD69",
                  color: "#111",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  marginBottom: "6px",
                  transition: "background .2s",
                  opacity: isLoading ? 0.6 : 1,
                }}
                disabled={isLoading}
                onClick={() => {
                  if (!isLoading) {
                    setShowGemConfirmModal(true);
                  }
                }}
              >
                {isLoading ? t('courses.processing') : t('courses.payWithGems')}
              </button>
              <button
                style={{
                  background: "#DFBD69",
                  color: "#111",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  marginBottom: "6px",
                  transition: "background .2s",
                  opacity: isLoading ? 0.6 : 1,
                }}
                disabled={isLoading}
                onClick={() => {
                  if (!isLoading) {
                    openStripeModal(selectedCourse?.CASH_AMT);
                    setSelectedPlan(selectedCourse?.TITLE);
                    setShowPaymentModal(false);
                  }
                }}
              >
                {isLoading ? t('courses.processing') : t('courses.payWithCard')}
              </button>
            </div>
          </div>
        </div>
      )}
      {showGemErrorModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1003,
          }}
          onClick={() => setShowGemErrorModal(false)}
        >
          <div
            style={{
              backgroundColor: "#1a1a1a",
              padding: "32px 28px 24px 28px",
              borderRadius: "15px",
              width: "350px",
              maxWidth: "90vw",
              color: "#DFBD69",
              position: "relative",
              boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={e => e.stopPropagation()}
          >
            <h2 style={{ color: "#DFBD69", marginBottom: "18px", textAlign: "center" }}>{t('courses.gemPaymentError')}</h2>
            <div style={{ marginBottom: "24px", color: "#DFBD69", fontSize: "1.1em", textAlign: "center" }}>
              {gemErrorMessage}
            </div>
            <button
              style={{
                background: "#DFBD69",
                color: "#111",
                border: "none",
                borderRadius: "8px",
                padding: "12px 32px",
                fontWeight: "bold",
                fontSize: "1rem",
                cursor: "pointer",
                transition: "background .2s",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                margin: "0 auto",
              }}
              onClick={() => setShowGemErrorModal(false)}
            >
              {t('courses.close')}
            </button>
          </div>
        </div>
      )}
      {showGemConfirmModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1001,
          }}
          onClick={() => setShowGemConfirmModal(false)}
        >
          <div
            style={{
              backgroundColor: "#1a1a1a",
              padding: "32px 28px 24px 28px",
              borderRadius: "15px",
              width: "350px",
              maxWidth: "90vw",
              color: "#DFBD69",
              position: "relative",
              boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => setShowGemConfirmModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                color: "#DFBD69",
                fontSize: "1.8rem",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 2,
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h2 style={{ color: "#DFBD69", marginBottom: "18px" }}>{t('courses.confirmPaymentGems')}</h2>
            <div style={{ marginBottom: "18px", color: "#DFBD69", fontSize: "1.1em", textAlign: "center" }}>
              {t('courses.gemPaymentMessage', { 
                otherAmt: selectedCourse?.OTHER_AMT || selectedCourse?.GEM_AMT || 0 
              })}
              <br />
              <strong style={{ fontWeight: 700 }}>
                {selectedCourse?.OTHER_AMT || selectedCourse?.GEM_AMT || 0} Gems
              </strong>
            </div>
            <div style={{ display: "flex", gap: "12px", marginTop: "10px", justifyContent: "center" }}>
              <button
                style={{
                  background: "#DFBD69",
                  color: "#111",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: (isLoading || isGemPaymentLoading) ? "not-allowed" : "pointer",
                  transition: "background .2s",
                  opacity: (isLoading || isGemPaymentLoading) ? 0.6 : 1,
                }}
                disabled={isLoading || isGemPaymentLoading}
                onClick={async () => {
                  if (isLoading || isGemPaymentLoading) return;
                  
                  setIsLoading(true);
                  
                  try {
                    const latestCoins = await fetchData();
                    const requiredGems = selectedCourse?.OTHER_AMT || selectedCourse?.GEM_AMT || 0;
                    
                    console.log("Gem check - Required:", requiredGems, "Available:", latestCoins);
                    
                    if (!latestCoins || latestCoins <= 0 || requiredGems > latestCoins) {
                      setShowGemConfirmModal(false);
                      setInsufficientGemsModal({ show: true, required: requiredGems, current: latestCoins || 0 });
                      return;
                    }
                    
                    // ✅ Save the title BEFORE handlePayment clears selectedCourse
                    const courseTitle = selectedCourse?.TITLE || "the course";
                    setPurchasedCourseTitle(courseTitle);
                    
                    setShowGemConfirmModal(false);
                    await handlePayment();
                    setShowPaymentModal(false);
                    setShowGemSuccessModal(true);
                  } finally {
                    setIsLoading(false);
                  }
                }}

              >
                {(isLoading || isGemPaymentLoading) ? t('courses.processing') : t('courses.accept')}
              </button>
              <button
                style={{
                  background: "#222",
                  color: "#DFBD69",
                  border: "1px solid #DFBD69",
                  borderRadius: "8px",
                  padding: "12px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: "pointer",
                  transition: "background .2s",
                }}
                onClick={() => setShowGemConfirmModal(false)}
              >
                {t('courses.cancel')}
              </button>
            </div>
          </div>
        </div>
      )}
      {showGemSuccessModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1002,
          }}
          onClick={() => {
            setShowGemSuccessModal(false);
            window.location.reload();
          }}
        >
          <div
            style={{
              backgroundColor: "#1a1a1a",
              padding: "32px 28px 24px 28px",
              borderRadius: "15px",
              width: "350px",
              maxWidth: "90vw",
              color: "#DFBD69",
              position: "relative",
              boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => {
                setShowGemSuccessModal(false);
                setPurchasedCourseTitle(""); // Clear on close
                window.location.reload();
              }}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                color: "#DFBD69",
                fontSize: "1.8rem",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 2,
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h2 style={{ color: "#DFBD69", marginBottom: "18px", textAlign: "center" }}>{t('courses.success')}</h2>
            <div style={{ marginBottom: "18px", color: "#DFBD69", fontSize: "1.1em", textAlign: "center" }}>
              {t('courses.successMessage').replace('{selectedCourse?.TITLE}', purchasedCourseTitle)}
            </div>
            <button
              style={{
                background: "#DFBD69",
                color: "#111",
                border: "none",
                borderRadius: "8px",
                padding: "12px 32px",
                fontWeight: "bold",
                fontSize: "1rem",
                cursor: "pointer",
                marginBottom: "6px",
                transition: "background .2s",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
              onClick={() => {
                setShowGemSuccessModal(false);
                window.location.reload();
              }}
            >
              {t('courses.close')}
            </button>
          </div>
        </div>
      )}
      {/* Insufficient Gems Modal */}
      {insufficientGemsModal.show && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10000
          }}
          onClick={() => setInsufficientGemsModal({ show: false, required: 0, current: 0 })}
        >
          <div
            style={{
              backgroundColor: '#1a1a1a',
              padding: '30px',
              borderRadius: '15px',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              border: '2px solid #DFBD69',
              position: 'relative'
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => setInsufficientGemsModal({ show: false, required: 0, current: 0 })}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                color: '#DFBD69',
                fontSize: '1.8rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                zIndex: 2,
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h2 style={{ color: '#ef4444', marginBottom: '20px' }}>{t('courses.insufficientGems')}</h2>
            <p style={{ color: '#DFBD69', marginBottom: '15px', fontSize: '16px' }}>
              {t('courses.insufficientGemsMessage')}
            </p>
            <div style={{ 
              backgroundColor: '#222', 
              padding: '15px', 
              borderRadius: '8px',
              marginBottom: '20px',
              border: '1px solid #DFBD69'
            }}>
              <p style={{ color: '#DFBD69', marginBottom: '10px' }}>
                <strong>{t('courses.required')}:</strong> {insufficientGemsModal.required} Gems
              </p>
              <p style={{ color: '#DFBD69' }}>
                <strong>{t('courses.youHave')}:</strong> {insufficientGemsModal.current} Gems
              </p>
            </div>
            <p style={{ color: '#DFBD69', marginBottom: '10px', fontSize: '14px' }}>
              {t('courses.buyMoreGems')}
            </p>
            <p style={{ color: '#a67c00', marginBottom: '20px', fontSize: '14px', fontWeight: 'bold' }}>
              {t('courses.buyWithCard')}
            </p>
            <button
              onClick={() => {
                setInsufficientGemsModal({ show: false, required: 0, current: 0 });
                openStripeModal(selectedCourse?.CASH_AMT);
                setSelectedPlan(selectedCourse?.TITLE);
              }}
              style={{
                background: '#a67c00',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '12px',
                fontWeight: 'bold',
                fontSize: '1rem',
                cursor: 'pointer',
                marginBottom: '10px',
                width: '100%',
                transition: 'background .2s',
              }}
            >
              {t('courses.payWithCard')}
            </button>
            <button
              onClick={() => setInsufficientGemsModal({ show: false, required: 0, current: 0 })}
              style={{
                background: '#DFBD69',
                color: '#111',
                border: 'none',
                borderRadius: '8px',
                padding: '12px',
                fontWeight: 'bold',
                fontSize: '1rem',
                cursor: 'pointer',
                width: '100%',
                transition: 'background .2s',
              }}
            >
              {t('courses.close')}
            </button>
          </div>
        </div>
      )}
      
      {/* Stripe Payment Modal */}
      {modalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
          }}
          onClick={closeStripeModal}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              minWidth: "300px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <StripePayment
              id="payment by card"
              amount={convert(stripecost)}
              currency={currency.toLowerCase()}
              isOpen={modalOpen}
              onClose={closeStripeModal}
              onPaymentSuccess={handlePurchasebyCard}
            />
          </div>
        </div>
      )}
      {/* Payment Success Modal */}
      {/* <Modal
        isOpen={handlePaymentSuccess}
        onRequestClose={closeSuccessModal}
        style={{
          content: {
            width: "388px",
            height: "35%",
            margin: "auto",
            padding: "20px",
            backgroundColor: "black",
          },
        }}
      > */}
        {/* Simple close button */}
        {/* <button
          onClick={closeSuccessModal}
          style={{
            position: "absolute",
            top: "12px",
            right: "16px",
            background: "none",
            border: "none",
            color: "#DFBD69",
            fontSize: "1.8rem",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 2,
          }}
          aria-label="Close"
        >
          ×
        </button>
        <h2 style={{ color: "#DFBD69" }}>Reservation</h2>
        <p style={{ color: "#DFBD69" }}>{message}</p>
        <button
          onClick={closeSuccessModal}
          style={{
            background: "#DFBD69",
            color: "#111",
            border: "none",
            borderRadius: "8px",
            padding: "12px",
            fontWeight: "bold",
            fontSize: "1rem",
            cursor: "pointer",
            marginTop: "18px",
            transition: "background .2s",
          }}
        >
          Close
        </button>
      </Modal> */}

      {/* Payment Failed Modal */}
      {/* <Modal
        isOpen={handlePaymentFailed}
        onRequestClose={closeFailedModal}
        style={{
          content: {
            width: "388px",
            height: "35%",
            margin: "auto",
            padding: "20px",
            backgroundColor: "black",
          },
        }}
      >
        <h2 style={{ color: "#DFBD69" }}>Payment Failed</h2>
        <p style={{ color: "#DFBD69" }}>{message}</p>
        <button
          onClick={closeFailedModal}
          style={{
            background: "#DFBD69",
            color: "#111",
            border: "none",
            borderRadius: "8px",
            padding: "12px",
            fontWeight: "bold",
            fontSize: "1rem",
            cursor: "pointer",
            marginTop: "18px",
            transition: "background .2s",
          }}
        >
          Close
        </button>
      </Modal> */}

      {/* Guardian Confirmation Modal */}
      {guardianModal.show && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10002 }}
          onClick={() => setGuardianModal({ show: false, pendingCost: null })}>
          <div style={{ backgroundColor: "#1a1a1a", borderRadius: 12, padding: "28px 24px", width: "min(460px, 92vw)", textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,0.45)", border: "1px solid rgba(223,189,105,0.25)" }}
            onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: "#DFBD69", margin: "0 0 16px", fontSize: "1.2rem" }}>{t("cart.guardianConfirmationRequired")}</h3>
            <p style={{ color: "#fff2d2", marginBottom: 28, lineHeight: 1.6 }}>{t("cart.guardianMessage")}</p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button style={{ background: "#DFBD69", color: "#151517", border: "none", borderRadius: 8, padding: "10px 22px", fontWeight: 700, cursor: "pointer", fontSize: "0.95rem" }}
                onClick={() => {
                  const cost = guardianModal.pendingCost;
                  setGuardianModal({ show: false, pendingCost: null });
                  setStripeCost(cost);
                  setIsConfirmationModalOpen(false);
                  setModalOpen(true);
                  setIsModalOpen(false);
                }}>
                {t("cart.yesProceed")}
              </button>
              <button style={{ background: "transparent", color: "#DFBD69", border: "1px solid rgba(223,189,105,0.4)", borderRadius: 8, padding: "10px 22px", cursor: "pointer", fontSize: "0.95rem" }}
                onClick={() => setGuardianModal({ show: false, pendingCost: null })}>
                {t("cart.noCancel")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

};

export default CourseList;

// Helpers
function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) {
    return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  }
  return `${m}:${s.toString().padStart(2, "0")}`;
}

function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) {
    return `${h}h ${m}m`;
  }
  return `${m}m`;
}